<script>
export default {
  name: 'CountUp',
  props: {
    value: Number,
  },
  data: () => {
    return {
      displayNumber: 0,
      increment: 30, 
    }
  },
  mounted() {
    this.countUp();
  },
  methods: {
    countUp() {
      if (this.displayNumber === this.value)
        return;
      this.displayNumber++;
      setTimeout(() => {
        this.increment = this.increment * 1.08;
        this.countUp();
      }, this.increment);
    },
  },
};
</script>

<template>
  <span class="count-up">
    {{ displayNumber }}
  </span>
</template>

<style lang="scss" scoped>

</style>